<template>
  <vf-select
    v-model="modelValue"
    :class="brandClasses.container"
    data-test-id="select-sort"
    :disabled
    :icon-class="brandClasses.icon"
    :icon-size
    :invalid
    :options
    :text-class="brandClasses.text"
    @update:model-value="$emit('change', $event)"
  >
    <span data-test-id="select-sort-label">
      {{ label }}
    </span>
  </vf-select>
</template>

<script lang="ts" setup>
import type { SelectOption } from '#types/components/base/select'

const { label } = defineProps<{
  /**
   * Defines the label text
   */
  label: string
  /**
   * Defines list of options
   */
  options: (string | SelectOption)[] | (() => Promise<SelectOption[]>)
  /**
   * Defines disabled state
   */
  disabled?: boolean
  /**
   * Defines invalid state
   */
  invalid?: boolean
}>()

defineEmits<{ change: [value?: string | number | object] }>()

const modelValue = defineModel<string | number | object>()

const { iconSize, sort: { brandClasses } } = useAppConfig().components.vf.select
</script>
